"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Menu = Menu;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _reactInstantsearchHooks = require("react-instantsearch-hooks");

var _Menu = require("../ui/Menu");

var _excluded = ["attribute", "limit", "showMore", "showMoreLimit", "sortBy", "transformItems", "translations"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function Menu(_ref) {
  var attribute = _ref.attribute,
      limit = _ref.limit,
      showMore = _ref.showMore,
      showMoreLimit = _ref.showMoreLimit,
      sortBy = _ref.sortBy,
      transformItems = _ref.transformItems,
      translations = _ref.translations,
      props = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useMenu = (0, _reactInstantsearchHooks.useMenu)({
    attribute: attribute,
    limit: limit,
    showMore: showMore,
    showMoreLimit: showMoreLimit,
    sortBy: sortBy,
    transformItems: transformItems
  }, {
    $$widgetType: 'ais.menu'
  }),
      canToggleShowMore = _useMenu.canToggleShowMore,
      isShowingMore = _useMenu.isShowingMore,
      items = _useMenu.items,
      refine = _useMenu.refine,
      createURL = _useMenu.createURL,
      toggleShowMore = _useMenu.toggleShowMore;

  var uiProps = {
    items: items,
    createURL: createURL,
    onRefine: function onRefine(item) {
      return refine(item.value);
    },
    canToggleShowMore: canToggleShowMore,
    onToggleShowMore: toggleShowMore,
    isShowingMore: isShowingMore,
    translations: _objectSpread({
      showMoreButtonText: function showMoreButtonText(options) {
        return options.isShowingMore ? 'Show less' : 'Show more';
      }
    }, translations)
  };
  return /*#__PURE__*/_react.default.createElement(_Menu.Menu, (0, _extends2.default)({}, props, uiProps, {
    showMore: showMore
  }));
}